export default "__VITE_ASSET__CKBAw96g__"